<!-- 错题集 -->
<template>
  <div class="el-ErrorSet">
    <el-row class="content_block mb30">
      <TitleInfo title="错题集" :titleImg="ct_b"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-row style="text-align: right;margin-bottom: 20px;">
          <el-button type="primary">错题练习</el-button>
          <el-button type="success">导出</el-button>
        </el-row>
        <el-row>
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
            <el-table-column prop="title" header-align="center" align="left" label="题干">
              <template slot-scope="scope">
                <el-row v-html="$getReplace(scope.row.questionStem)"></el-row>
              </template>
            </el-table-column>
            <el-table-column prop="type" header-align="center" align="center" label="题型" width="100"> </el-table-column>
            <el-table-column prop="wdxx" header-align="center" align="center" label="我的选项" width="180"> </el-table-column>
            <el-table-column prop="zqda" header-align="center" align="center" label="正确答案" width="180"> </el-table-column>
            <el-table-column prop="messageAcceptState" header-align="center" align="center" label="状态" width="100">
              <template slot-scope="scope">
                  <span :class="scope.row.messageAcceptState === 1?'':'wd'">{{scope.row.messageAcceptState == 1?"错误":"正确"}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="180">
              <template slot-scope="scope">
                <el-link type="primary" class="mr20" :underline="false" @click="">查看</el-link>
                <el-link type="primary" :underline="false" @click="">移出</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              background
              :hide-on-single-page="true"
              layout="sizes, prev, pager, next,jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
export default {
  name: "ErrorSet",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      ct_b:require("../../images/course/ct_b@2x.png"),
      tableData:[
        {title:"无论是企业治理还是个人的业务往束资宝，都必须合法合规。合情合理",type:"多选",wdxx:"A、B、C",zqda:"A、B、C、D"},
        {title:"无论是企业治理还是个人的业务往束资宝，都必须合法合规。合情合理",type:"多选",wdxx:"A、B、C",zqda:"A、B、C、D"},
        {title:"无论是企业治理还是个人的业务往束资宝，都必须合法合规。合情合理",type:"多选",wdxx:"A、B、C",zqda:"A、B、C、D"},
        {title:"无论是企业治理还是个人的业务往束资宝，都必须合法合规。合情合理",type:"多选",wdxx:"A、B、C",zqda:"A、B、C、D"},
        {title:"无论是企业治理还是个人的业务往束资宝，都必须合法合规。合情合理",type:"多选",wdxx:"A、B、C",zqda:"A、B、C、D"},
        {title:"无论是企业治理还是个人的业务往束资宝，都必须合法合规。合情合理",type:"多选",wdxx:"A、B、C",zqda:"A、B、C、D"},
        {title:"无论是企业治理还是个人的业务往束资宝，都必须合法合规。合情合理",type:"多选",wdxx:"A、B、C",zqda:"A、B、C、D"}
      ],
      noticeList:[], //当前页数据

      total: 11,
      limit:10,
      page:1
    };
  },
  created() {

  },
  mounted() {
    this.getInfo();
  },
  methods: {
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val;
        this.getInfo();
    },
    getInfo(){ //获取通知公告列表
      // this.$store.dispatch("user/getNoticeList",{limit:this.limit,page:this.page})
      // .then((ret) => {
      //   if(ret.code == 0){
      //     this.noticeList = ret.data;
      //     this.total = ret.count;
      //   }else{
      //     this.$message({
      //        message: ret.msg,
      //        type: "warning"
      //     });
      //   }
      // });
    },
  }
};
</script>
 <style  lang="less">
  .el-ErrorSet{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/ErrorSet.vue